export const REPORT_VIEW = {
  plaqueIndex: 'plaqueIndex',
  periodontal: 'periodontal',
  screening: 'screening',
  brushMap: 'brushMap',
  riskMap: 'riskMap',
} as const

export const RESULT_STATUS = {
  bad: 'exception',
  unsatisfactory: 'warning',
  good: 'success',
} as const

export const LOGO =
  // eslint-disable-next-line max-len
  '<svg width="92" height="28" viewBox="0 0 138 42" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1320_72101)"><path d="M0.0533096 37.327C-0.0281865 37.2438 -0.0281865 4.78047 0.0533096 4.71116C0.134806 4.66958 23.9452 4.64185 24.9504 4.71116C28.0336 4.90522 30.5464 5.5567 32.9098 6.77651C34.3632 7.51116 35.6943 8.48146 36.8488 9.64581C37.6637 10.4914 38.3836 11.4339 38.9949 12.4458C40.1222 14.4003 40.8013 16.4656 41.1002 18.9607C41.2088 19.9171 41.2088 21.9824 41.1409 22.9112C40.8013 25.7112 40.0136 28.0537 38.6689 30.1607C38.1663 30.923 37.6094 31.6161 36.9846 32.2676C35.7758 33.529 34.3496 34.5686 32.774 35.3309C30.3699 36.5508 27.8571 37.1745 24.8145 37.327C23.6057 37.4102 0.134806 37.3686 0.0533096 37.327ZM24.6923 32.4201C26.9063 32.3092 28.6313 31.8517 30.3699 30.9646C31.375 30.4517 32.2986 29.7587 33.0728 28.927C34.6891 27.2359 35.5856 25.129 35.8844 22.4121C35.9523 21.3587 35.9387 20.2914 35.8437 19.224C35.5856 17.4636 35.1238 16.0775 34.336 14.7329C33.7384 13.7626 32.9913 12.9171 32.122 12.2102C30.4649 10.8656 28.4004 10.0201 26.037 9.71512C24.8417 9.56264 24.5021 9.56264 14.4645 9.56264L4.80725 9.60423L4.7665 20.9844V32.4062L4.80725 32.4478H14.3966C20.2643 32.4616 24.2848 32.4616 24.6923 32.4201Z" fill="currentColor"/><path d="M45.8838 7.33279C45.8838 5.76646 47.1334 4.49121 48.6682 4.49121C50.2031 4.49121 51.4527 5.76646 51.4527 7.33279C51.4527 8.89913 50.2031 10.1744 48.6682 10.1744C47.1334 10.1882 45.8838 8.91299 45.8838 7.33279ZM46.658 37.0932V13.8061H50.6921V37.0932H46.658Z" fill="currentColor"/><path d="M80.3158 13.8059V37.0931H76.2818V32.8792C76.078 33.1426 75.8607 33.3921 75.6298 33.6416C74.5568 34.7782 73.2393 35.7485 71.7316 36.4277C70.2239 37.1069 68.5397 37.4673 66.8554 37.4951C65.1712 37.5089 63.4597 37.204 61.8977 36.5941C60.3357 35.9842 58.9231 35.0555 57.755 33.9188C55.4188 31.6455 54.1149 28.5406 54.142 25.4356C54.1284 22.3307 55.4324 19.2257 57.7686 16.9525C58.9367 15.8297 60.3493 14.901 61.9113 14.2911C63.4733 13.6812 65.1847 13.3762 66.869 13.3901C68.5532 13.4317 70.2375 13.7921 71.7452 14.4574C73.2528 15.1366 74.5704 16.0931 75.6434 17.2436C75.8743 17.4931 76.0916 17.7426 76.2954 18.0059V13.7782H80.3158V13.8059ZM76.2818 25.4495C76.2954 23.1069 75.168 20.8198 73.3343 19.3228C71.5278 17.798 69.1645 17.0772 66.869 17.1327C64.5599 17.1743 62.3324 18.0891 60.7296 19.6277C59.0997 21.1525 58.1625 23.2871 58.1625 25.4495C58.1761 27.6257 59.1133 29.7465 60.7432 31.2713C61.5446 32.0337 62.509 32.6574 63.5548 33.0733C64.6007 33.503 65.728 33.7386 66.8826 33.7525C69.178 33.8079 71.5414 33.0871 73.3479 31.5624C75.1544 30.0792 76.2818 27.7921 76.2818 25.4495Z" fill="currentColor"/><path d="M101.953 37.093L101.967 24.2574V23.8554L101.953 23.5088C101.94 23.2732 101.926 23.0514 101.899 22.8296C101.844 22.3722 101.763 21.9425 101.654 21.5267C101.423 20.695 101.016 19.9049 100.527 19.295C99.5218 18.0613 98.0956 17.3683 96.3027 17.2574C94.5234 17.1465 92.812 17.5623 91.4401 18.8653C90.7746 19.5029 90.2041 20.3485 89.8374 21.2772C89.4571 22.2059 89.2805 23.2039 89.2126 24.2712C89.199 24.4098 89.199 24.5623 89.1854 24.7009V37.1069H85.1514V13.8197H89.1854V17.6316C89.2126 17.5762 89.2397 17.5069 89.2805 17.4514C89.9325 16.3425 90.9376 15.3306 92.1872 14.6376C92.812 14.3049 93.4911 14.0277 94.1838 13.8475C94.8901 13.6673 95.5964 13.5702 96.3027 13.5425C97.7017 13.4871 99.223 13.7227 100.581 14.3326C101.94 14.9287 103.135 15.899 103.963 17.0217C105.62 19.2673 106.055 21.9702 105.987 24.2574L106.001 37.093H101.953Z" fill="currentColor"/><path d="M135.449 13.8059V37.0931H131.415V32.8792C131.211 33.1426 130.994 33.3921 130.763 33.6416C129.69 34.7782 128.372 35.7485 126.864 36.4277C125.357 37.1069 123.672 37.4673 121.988 37.4951C120.304 37.5089 118.593 37.204 117.031 36.5941C115.469 35.9842 114.056 35.0555 112.888 33.9188C110.552 31.6455 109.248 28.5406 109.275 25.4356C109.261 22.3307 110.565 19.2257 112.901 16.9525C114.07 15.8297 115.482 14.901 117.044 14.2911C118.606 13.6812 120.318 13.3762 122.002 13.3901C123.686 13.4317 125.37 13.7921 126.878 14.4574C128.386 15.1366 129.703 16.0931 130.776 17.2436C131.007 17.4931 131.224 17.7426 131.428 18.0059V13.7782H135.449V13.8059ZM131.415 25.4495C131.428 23.1069 130.287 20.8198 128.467 19.3228C126.661 17.798 124.297 17.0772 122.002 17.1327C119.693 17.1743 117.465 18.0891 115.862 19.6277C114.233 21.1525 113.295 23.2871 113.295 25.4495C113.309 27.6257 114.246 29.7465 115.876 31.2713C116.677 32.0337 117.642 32.6574 118.688 33.0733C119.734 33.503 120.861 33.7386 122.015 33.7525C124.311 33.8079 126.674 33.0871 128.481 31.5624C130.287 30.0792 131.415 27.7921 131.415 25.4495Z" fill="currentColor"/></g><defs><clipPath id="clip0_1320_72101"><rect width="138" height="42" fill="white"/></clipPath></defs></svg>'

export const CONSULTATIONS_MAP = new Map([
  ['therapist', 'Терапевта'],
  ['surgeon', 'Хирурга'],
  ['hygienist', 'Гигиениста'],
  ['periodontist', 'Пародонтолога'],
  ['orthodontist', 'Ортодонта'],
  ['orthopedist', 'Ортопеда'],
  ['pediatricDentist', 'Детского стоматолога'],
])

export const MEASURES_MAP = new Map([
  ['hygieneLesson', 'Урок гигиены'],
  ['screening', 'Пародонтальный скрининг'],
  ['brushMap', 'Карта ершиков'],
  ['periodontal', 'Пародонтальная карта'],
])

export const HOME_TOOLS = new Map([
  [
    333,
    'Чистка зубов два раза в день: утром до завтрака и вечером после ужина',
  ],
  [444, 'Зубная щётка'],
  [555, 'Зубная паста'],
  [556, 'Зубная нить, после каждого приема пищи'],
  [557, 'Ирригатор, при необходимости - после каждого приема пищи'],
  [558, 'Ёршик для очистки межзубных пространств, после каждого приема пищи'],
  [
    559,
    'Домашний контроль гигены полости рта с помощью индикаторов налета, раз в неделю',
  ],
  [560, 'Скребок для языка, раз в день'],
  [
    561,
    'Щетка монопучковая для тщательного ухода за придесневой зоной зубов и труднодоступных мест',
  ],
])

export const BRUSH_TYPE = new Map([
  [1, 'Зубная щётка: чень мягкая (ультрасофт)'],
  [2, 'Зубная щётка: мягкая (софт)'],
  [3, 'Зубная щётка: средней жесткости (медиум)'],
  [4, 'Зубная щётка: жесткая (хард)'],
])

export const TOOTHPASTE_TYPE = new Map([
  [33345, 'Зубная паста: с ферментами'],
  [33346, 'Зубная паста: отбеливающая'],
  [33347, 'Зубная паста: профилактическая'],
])

export const PLAQUE_INDEX_MAP = [
  {
    subtitle: 'моляры',
    class: 'molars',
  },
  {
    subtitle: 'премоляры',
    class: 'premolars',
  },
  {
    subtitle: 'клык',
    class: 'fang',
  },
  {
    subtitle: 'резцы',
    class: 'incisors',
  },
  {
    subtitle: 'клык',
    class: 'fang',
  },
  {
    subtitle: 'премоляры',
    class: 'premolars',
  },
  {
    subtitle: 'моляры',
    class: 'molars',
  },
]

export const CHECKED_ICON_SVG =
  '<svg width="10" height="9" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
  '<path d="M1 5.2L4.47826 10L11 1" stroke="white" stroke-width="2" stroke-linecap="round"/>' +
  '</svg>'
